import { InfiniteData, useInfiniteQuery } from '@tanstack/react-query'

import { PAGINATION, QUERY_KEYS } from '@/api/constants'
import { apiGetSessions, TGetSessionsResponse } from '@/api/session'

export const useSessionsInfinite = () =>
  useInfiniteQuery<TGetSessionsResponse, Error, InfiniteData<TGetSessionsResponse>, string[], number>({
    queryKey: [QUERY_KEYS.SESSIONS],
    queryFn: ({ pageParam }) => apiGetSessions(pageParam, PAGINATION.DEFAULT_LIMIT),
    initialPageParam: PAGINATION.DEFAULT_SKIP,
    getNextPageParam: (lastPage) => {
      const nextSkip = lastPage.skip + lastPage.limit
      return nextSkip < lastPage.total ? nextSkip : undefined
    },
  })
